
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'detailsContainer': {'padding': `0px 20px`,},'addressDetails': {'padding': `18px 0px 18px 0px`,},'largerBoldText': {'fontWeight': `bold`,'fontWeight': `bold`,'fontSize': `14px`,'color': `#000000`,'marginBottom': `16px`,'fontSize': `18px`,'fontFamily': `'Lato-Regular-Bold', sans-serif`,},'boldText': {'fontWeight': `bold`,'fontSize': `14px`,'color': `#000000`,},'dateAndTime': {'fontWeight': `bold`,'fontSize': `14px`,'color': `#000000`,'fontWeight': `bold`,},'timeDetails': {'marginBottom': `16px`,},
        
      };
    };
  